<template>
  <div id="article-list" class="flex-column">
    <list-head
      :statusCount="statusCount"
      :tabActive="currentTab"
      :searchText="searchText"
      @tab="setTab"
      @search="setSearchText"
    ></list-head>
    <list-content
      :currentTab="currentTab"
      :currentSearchText="searchText"
      @statusCount="setCounters"
    ></list-content>
  </div>
</template>

<script>
import ListHead from "@/components/admin/view/article/list/ListHead";
import ListContent from "@/components/admin/view/article/list/ListContent";

export default {
  name: "article-list",
  components: {
    ListHead,
    ListContent
  },
  data() {
    return {
      currentTab: "draft",
      searchText: "",
      // counter
      statusCount: {
        draft: 0,
        toBeApproved: 0,
        toBePublished: 0,
        published: 0,
        all: 0
      }
    };
  },
  created() {
    this.$store.state.currentArticleType = this.$route.params.articleType;

    if (this.$route.params.articleStatus) {
      this.currentTab = this.$route.params.articleStatus;
    } else {
      this.$store.state.currentArticleStatus = this.currentTab;
    }
  },
  methods: {
    setTab(tab) {
      this.currentTab = tab;
      this.$store.state.currentArticleStatus = this.currentTab;

      this.$router.push({
        name: "ArticleListStatus",
        params: {
          articleType: this.$route.params.articleType,
          articleStatus: this.currentTab
        }
      });
    },
    setSearchText(text) {
      this.searchText = text;
    },
    setCounters(newCounter) {
      this.statusCount = newCounter;
    }
  }
};
</script>

<style scoped>
#article-list {
  flex-grow: 1;
  flex-basis: 0;
  border-top: 1px solid #e0e0e0;
}
.cover {
  width: 160px;
  height: 120px;
  background-color: #d8d8d8;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/article/ArticleList.vue